import { jsx as i } from "react/jsx-runtime";
import { forwardRef as p } from "react";
import { useStyleConfig as a, Tooltip as n } from "@chakra-ui/react";
const d = p(({ variant: r, ...o }, t) => {
  const e = a("TooltipTheme", {
    variant: r
  });
  return /* @__PURE__ */ i(
    n,
    {
      ...o,
      arrowSize: 12,
      hasArrow: !0,
      ref: t,
      sx: {
        "[data-popper-arrow]": {
          // This is a hack to make the tooltip arrow appear above the tooltip content, current z-index is -1 added by js
          zIndex: "auto !important"
        }
      },
      modifiers: [
        {
          name: "preventOverflow",
          options: {
            altAxis: !0,
            padding: 24
          }
        }
      ],
      ...e,
      children: o.children
    }
  );
});
export {
  d as Tooltip
};
//# sourceMappingURL=Tooltip.es.js.map
